<template>
  <div class="reset-container">
    <h1>{{ $t("FormForgotPassword.title") }}</h1>
    <el-form label-position="top" class="reset-form" @submit.prevent="handleSubmit">
      <el-form-item class="mt-12">
        <template #label>
          <label>
            {{ $t("FormForgotPassword.email") }}
            <el-input
              v-model="email"
              type="email"
              autofocus
              :placeholder="$t('FormForgotPassword.email')"
            />
          </label>
        </template>
      </el-form-item>
      <div class="flex justify-start mt-8">
        <el-button
          class="has-icon"
          :disabled="!isValidEmail || isLoading"
          :loading="isLoading"
          size="default"
          @click="sendResetEmail"
        >
          <SvgIcon name="check-circle" />
          {{ $t("FormForgotPassword.button") }}
        </el-button>
      </div>
    </el-form>
  </div>
</template>
<script setup>
import { ref, computed, h } from "vue";
import { useUserStore } from "@/store/User";
import { ElNotification } from "element-plus";
import { useI18n } from 'vue-i18n';

const userStore = useUserStore();

const email = ref("");
const { t } = useI18n();
const isLoading = ref(false);

const isValidEmail = computed(() => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return email.value.length > 0 && emailRegex.test(email.value);
});

const sendResetEmail = async () => {
  isLoading.value = true;
  try {
    await userStore.forgotPassword(email.value);
    ElNotification({
      title: t("FormForgotPassword.successTitle"),
      message: h(
        "div",
        { style: "color: teal; white-space: pre-line" },
        t("FormForgotPassword.successText")
      ),
    });
  } finally {
    isLoading.value = false;
    email.value = "";
  }
};

const handleSubmit = () => {
  if (isValidEmail.value && !isLoading.value) {
    sendResetEmail();
  }
};
</script>
